import times from 'lodash/times';
import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { HtmlTable } from '../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';
import { ColumnChartLoading } from '../../../CommonComponents/OPL/charts/ColumnChart/ColumnChart.loading';

const ROWS_COUNT = 6;
const COLUMNS_COUNT = 6;

export const RmdDashboardLoading = () => {
  return (
    <Box display="flex" flexDirection="column" css="gap: 24px">
      <ColumnChartLoading isStacked={false} categoriesCount={1} />

      <HtmlTable>
        <table>
          <caption>
            <Shimmer width="100px" height="24px" />
          </caption>

          <thead>
            <tr>
              {times(COLUMNS_COUNT).map(key => (
                <th key={key}>&nbsp;</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {times(ROWS_COUNT).map(key => (
              <tr key={key}>
                {times(COLUMNS_COUNT).map(cellKey => (
                  <td key={cellKey}>
                    <Shimmer width="100%" height="24px" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </HtmlTable>
    </Box>
  );
};
